import { useEffect, useState } from "react";
import { removeEmojis } from "../../../../utils/stringUtils";

export const useCategoryForm = (initialName: string, initialType: string, error: boolean, open: boolean) => {
  const [categoryName, setCategoryName] = useState(initialName);
  const [type, setType] = useState(initialType);
  const [hasError, setHasError] = useState(error);

  useEffect(() => {
    setCategoryName(initialName);
    setType(initialType);
    setHasError(error);
  }, [initialName, initialType, error, open]);

  // Change to accept string instead of event
  const handleCategoryNameChange = (value: string) => {
    let sanitized = removeEmojis(value).slice(0, 40);
    setCategoryName(sanitized.toUpperCase());
    setHasError(false);
  };

  const handleTypeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setType(event.target.value);
    setHasError(false);
  };

  const resetForm = () => {
    setCategoryName("");
    setType("");
    setHasError(false);
  };

  return {
    categoryName,
    type,
    hasError,
    setHasError,
    handleCategoryNameChange,
    handleTypeChange,
    resetForm,
  };
};
